module.exports = __webpack_public_path__ + "img/lx.fbdc0b69.png";